<div class="validation-container">
  <div class="breadcrumb-container" id="breadcrumb">
    <ng-casto-breadcrumb [currentPage]="'Validation'" [isUnlocked]="beautifiedBom"></ng-casto-breadcrumb>
  </div>
  @if (!installationDetails) {
    <div>
      <div class="d-flex justify-content-center">
        <h3>{{ 'popins.validation.error' | translate }}</h3>
      </div>
    </div>
  } @else {
    <div class="project-container">
      <div class="project-info-container">
        <ng-kitchen-validation-project-info
          [model$]="validationProjectInfo.asObservable()"
          [loading$]="validationProjectInfoLoading.asObservable()"
          (onRefreshRequested)="refreshComponents($event)"></ng-kitchen-validation-project-info>
      </div>
      <div class="project-resume-container">
        <ng-kitchen-validation-project-resume
          [model$]="validationProjectResume.asObservable()"
          [loading$]="validationProjectResumeLoading.asObservable()"></ng-kitchen-validation-project-resume>
      </div>
      <div class="side-bar-actions-container">
        <ng-kitchen-validation-side-bar-actions
          [model$]="validationSideBarActions.asObservable()"
          [loading$]="validationSideBarActionsLoading.asObservable()"
          (onRefreshRequested)="refreshComponents($event)"></ng-kitchen-validation-side-bar-actions>
      </div>
    </div>
  }
</div>
